/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import SearchService from '../../../../Services/SearchService';

// const TEXT_LIMIT = 18;

interface IComponentProps {
  name: string;
  id: string;
  vehicleString?: string;
  allGroupsString?: string;
  isSeachable?: boolean;
}

export default function CarsGroupCell(props: IComponentProps) {
  const [isLong, setIsLong] = React.useState<boolean>(false);
  const [isFound, setIsFound] = React.useState<boolean>(false);

  const renderElement = (name: string) => {
    return (
      <div
        title={name}
        id={`${props.id}`}
        className={isFound ? 'highlighted' : ''}
        style={{
          // paddingRight: '10px',
          whiteSpace: 'nowrap',
          width: '150px',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          display: 'inline-block',
          position: 'relative',
          top: '3px',
        }}
      >
        {/* {name.substring(0, TEXT_LIMIT)} ... */}
        {name}
      </div>
    );
  };

  React.useEffect(() => {
    const id = document.getElementById(props.id);
    if (id && !isLong && id.clientWidth >= 150) {
      setIsLong(true);
    }
  });

  React.useEffect(() => {
    const seachString = props.vehicleString || props.allGroupsString;
    const text = seachString ? SearchService.removeAccent(seachString.toLowerCase()) : '';
    const inputText = document.getElementById(`${props.id}`);
    if (inputText) {
      let innerHTML = props.name;
      if (text) {
        const innerHTMLAfterRemovedAccent = SearchService.removeAccent(props.name.toLowerCase());
        const index = innerHTMLAfterRemovedAccent.indexOf(text);
        if (index >= 0 && props.isSeachable) {
          setIsFound(true);
          innerHTML = `${innerHTML.substring(
            0,
            index
          )}<span style="color: rgb(123, 35, 95); font-weight: bold;" class='highlight'>${innerHTML.substring(
            index,
            index + text.length
          )}</span>${innerHTML.substring(index + text.length)}`;
          inputText.innerHTML = innerHTML;
        } else {
          setIsFound(false);
          inputText.innerHTML = props.name;
        }
      } else {
        setIsFound(false);
        inputText.innerHTML = props.name;
      }
    } else {
      setIsFound(false);
    }
  }, [props.vehicleString, props.allGroupsString]);

  return isLong && !isFound ? (
    renderElement(props.name)
  ) : (
    <div id={props.id} className={isFound ? 'highlighted' : ''} style={{ whiteSpace: 'nowrap' }}>
      {props.name}
    </div>
  );
}
